import React from 'react';
import { Stack, IStackProps } from '@grubhubprod/gh-cookbook-react';
import {
  RouterLink,
  Props as RouterLinkProps,
} from 'src/components/RouterLink/RouterLink';

export type DataTableLinkProps = RouterLinkProps & IStackProps;

export const DataTableLink: React.FC<DataTableLinkProps> = ({
  children,
  x = 'none',
  y = 'none',
  ...rest
}) => (
  <Stack x={x} y={y}>
    <RouterLink {...rest}>{children}</RouterLink>
  </Stack>
);
